/**
 * crm-app API 根路径（唯一开关见 src/config/app.js）
 */
export {
	APP_API_BASE,
	H5_API_ENV,
	H5_LOCAL_API_BASE,
	H5_PRODUCTION_API_BASE,
	resolveH5AppApiBase
} from '@/config/app'
